/**
 * @author Manne Hareesh
 * @description Reducer for the components in Category page
 */
import {
    FETCH_SCHEDULES,
    UPDATE_SEAT_DETAILS,
    FETCH_SEAT_LAYOUT,
    LOG_OUT_ACTION,
    ON_PASSENGER_FORM_CHANGE,
    RESET_PASSENGER_FORM,
    ADD_CLIENT_SIDE_DISCOUNT,
    UPDATE_EXTRA_SEAT_COUNT,
    ON_EXTRA_SEAT_FORM_CHANGE,
    RESET_BLOCKED_SEAT_TICKET_ID,
    ON_HOVER_SEAT_TICKET_ID,
    ON_EXPAND_SHARED_SEAT,
    REFRESH_SELECTED_SEATS,
    SET_SELECTED_TRIP_ROUTES,
    SET_VIP_TICKET_REASONS,
    SET_MAX_DISCOUNT_CONFIG
 } from '../actions/action-types';
import { roundNumber } from '../utils/math.utils';
import { getValuesOfJSonObject, isValid, isValidArray, isValidString, isValidNumber } from '../utils/utilities';

/**
 * Seat Object
 * {
      adjacent_seat_number: "1"
      amount_for_travels: 800
      amount_paid: null
      blocked_by: ""
      cgst: 20
      cgst_of_discounted_price: 20
      commission: 0
      direct_discount: null
      discount: 0
      discounted_cost_with_gst: 840
      discounted_cost_without_gst: 800
      fare: 800
      full_name: null
      gender: null
      gents_seat: 0
      gst: 40
      gst_of_discounted_price: 40
      id: 142504
      igst: 0
      igst_of_discounted_price: 0
      ladies_seat: 0
      phone_number: null
      seat_column_number: 2
      seat_number: "2"
      seat_row_number: 1
      seat_status: ""
      sgst: 20
      sgst_of_discounted_price: 20
      sleeper: 0
      ticket_cost: 840
      ticket_id: null
      travel_miles: 0
      trip_id: 1928
      upper_deck: 0
 * }
 */

  const getAdminBlockTripRouteId = (passenger) =>{
    if(isValid(passenger)&&isValid(passenger.trip_route_id)&&!isValid(passenger.ticket_id)){
      return passenger.trip_route_id;
    }
    return null;
  }
  
const getFormatedSeatObject=(seatObject)=>{
  let {
    discounted_cost_with_gst,
    fare,
    discounted_cost_without_gst,
    id,
    phone_number,
    sgst,
    cgst,
    igst,
    ticket_cost,
    seat_number,
    full_name,
    gender,
    amount_for_travels,
    blocked_by,
    cgst_of_discounted_price,
    sgst_of_discounted_price,
    igst_of_discounted_price,
    seat_status,
    gst,
    trip_id,
    ticket_id,
    ticket_agent_privilege,
    ladies_seat,
    gents_seat,
    seatShownPassenger
  }=seatObject;
  
  let adminBlockTripRouteId = getAdminBlockTripRouteId(seatShownPassenger);
  // Note: in cutroute mode privilege lives on seatShownPassenger, in non-cutroute it's at seat top-level.
  let ticketAgentPrivilege = isValid(ticket_agent_privilege) ? ticket_agent_privilege
    : (isValid(seatShownPassenger) ? seatShownPassenger.ticket_agent_privilege : null);
  return {
    discountedCostWithGst:discounted_cost_with_gst,
    fare:fare,
    discountedCostWithoutGst:discounted_cost_without_gst,
    id:id,
    phoneNumber:phone_number,
    sgst:sgst,
    cgst:cgst,
    igst:igst,
    ticketCost:ticket_cost,
    seatNumber:seat_number,
    fullName:full_name,
    gender:gender,
    amountForTravels:amount_for_travels,
    blockedBy:blocked_by,
    cgstOfDiscountedPrice:cgst_of_discounted_price,
    sgstOfDiscountedPrice:sgst_of_discounted_price,
    igstOfDiscountedPrice : igst_of_discounted_price,
    seatStatus:seat_status,
    gst:gst,
    tripId:trip_id,
    adminBlockTripRouteId:adminBlockTripRouteId,
    ticketId:ticket_id,
    ticketAgentPrivilege:ticketAgentPrivilege,
    ladies_seat,
    gents_seat,
    seatGroupId:seatObject.seat_group_id,
    seatShownPassenger
  }
}

const assignExtraSeatInfo = (extra_index) => {
  return {
    extra_fullName: null,
    extra_gender: null,
    extra_age: null,
    extra_fare: null,
    extra_remarks: null,
    extra_index
  }
}
  const initialState = {
    selectedSeats:null,
    boardingId:null,
    dropId:null,
    phoneNumber:null,
    emailId:null,
    remarks:null,
    blockedSeatTicketId:null,
    adminBlockTripRouteId:null,
    timeOfRelease : null,
    relaseTimeSeatId : null,
    extraSeatCount: 0,
    extraSeatInfoList: null,
    hoverSeatTicketId:null,
    expandedSharedSeatNumber:null,
    selectedTripRoute:null,
    vipTicketReasons:[],
    maxDiscountConfig:null
  }
  
  export const passengerFormReducer = (state = initialState,action) => {
      let newState = Object.assign({},state);
      switch (action.type) {  

        case ON_HOVER_SEAT_TICKET_ID:{
          let {
            hoverSeatTicketId
          }=action.payload;
          newState.hoverSeatTicketId=hoverSeatTicketId;
          return newState;
        }

        case ON_EXPAND_SHARED_SEAT:{
          let {
            expandedSeatNumber
          }=action.payload;
          newState.expandedSharedSeatNumber=expandedSeatNumber;
          return newState;
        }

        case SET_SELECTED_TRIP_ROUTES:{
          let selectedTripRoute =action.payload;
          newState.selectedTripRoute=selectedTripRoute;
          return newState;
        }

        case SET_VIP_TICKET_REASONS:{
          let vipTicketReasons =action.payload;
          newState.vipTicketReasons=vipTicketReasons;
          return newState;
        }

        case SET_MAX_DISCOUNT_CONFIG:{
          newState.maxDiscountConfig=action.payload;
          return newState;
        }
          
          case UPDATE_SEAT_DETAILS :
                let {
                    seatId,seatObject,
                    passengerInfo
                }=action.payload;


                if(!isValid(newState.blockedSeatTicketId)&&isValid(seatObject.ticket_id)){
                  newState.blockedSeatTicketId=seatObject.ticket_id;
                }
                let selectedSeats=newState["selectedSeats"];
                if(!isValidArray(selectedSeats)){
                  selectedSeats={}
                }
                if(!isValid(selectedSeats[seatId])){
                    let {
                      phone_number,
                      drop_location,
                      pickup_location,
                      email_id,
                      time_of_release,
                      remarks
                    }=passengerInfo;
                    newState.phoneNumber=phone_number;
                    newState.emailId=email_id;
                    newState.remarks=remarks;
                    if(isValidString(time_of_release)){
                      newState.timeOfRelease = time_of_release;
                      newState.relaseTimeSeatId = seatId;
                    }
                    if(isValidArray(pickup_location)&&isValid(pickup_location.id)){
                      newState.boardingId=pickup_location.id;
                    }else{
                      newState.boardingId=pickup_location;
                    }
                    if(isValidArray(drop_location)&&isValid(drop_location.id)){
                      newState.dropId=drop_location.id;
                    }else{
                      newState.dropId=drop_location;
                    }
                    selectedSeats[seatId] = getFormatedSeatObject(seatObject);
                    newState.adminBlockTripRouteId = selectedSeats[seatId].adminBlockTripRouteId;
                    if(isValid(passengerInfo)&&isValid(passengerInfo.age)){
                      selectedSeats[seatId].age=passengerInfo.age;
                    }
                    if(isValid(passengerInfo)&&isValid(passengerInfo.full_name)){
                      selectedSeats[seatId].fullName=passengerInfo.full_name;
                    }
                    if(isValid(passengerInfo)&&isValid(passengerInfo.gender)){
                      selectedSeats[seatId].gender=passengerInfo.gender;
                    }
                }else{
                    delete selectedSeats[seatId];

                    let blockedTicketId = null,adminBlockTripRouteId = null;
                    for (const key in selectedSeats) {
                      if (Object.hasOwnProperty.call(selectedSeats, key)) {
                        const element = selectedSeats[key];
                        if(element.seatStatus == "Blocked"){
                          if(isValid(element.ticketId)){
                          blockedTicketId = element.ticketId;
                          }else{
                            if(isValid(element.adminBlockTripRouteId)){
                              adminBlockTripRouteId = element.adminBlockTripRouteId;
                            }
                          }
                        }
                      }
                    }

                    newState.blockedSeatTicketId = blockedTicketId;
                    newState.adminBlockTripRouteId = adminBlockTripRouteId;
                    if(seatId === newState.relaseTimeSeatId){
                      newState.timeOfRelease = null;
                    }
                }
                newState["selectedSeats"]={...selectedSeats};
                return newState;

          case FETCH_SCHEDULES :{
            newState["selectedSeats"]=null;
            newState.blockedSeatTicketId = null;
            newState.adminBlockTripRouteId = null;
            return newState;
          }

          case RESET_BLOCKED_SEAT_TICKET_ID :{
            newState.blockedSeatTicketId = null;
            newState.adminBlockTripRouteId = null;
            return newState;
          }

          case FETCH_SEAT_LAYOUT:{
            newState["selectedSeats"]=null;
            newState.blockedSeatTicketId = null;
            newState.adminBlockTripRouteId = null;
            return newState;
          } 

          case ON_PASSENGER_FORM_CHANGE:{
            let{
              seatId,
              fullName,
              gender,
              age
            }=action.payload;
              let selectedSeats=newState["selectedSeats"];
              if(isValidArray(selectedSeats[seatId])){
                if(isValid(fullName)){
                  selectedSeats[seatId].fullName=fullName;
                }
                if(isValid(age)){
                  selectedSeats[seatId].age=age;
                }
                if(isValid(gender)){
                  selectedSeats[seatId].gender=gender;
                }
              }
            return newState;
          }


          case ADD_CLIENT_SIDE_DISCOUNT :{
            let {
              discountPerSeat
            }=action.payload;
            let selectedSeats=newState["selectedSeats"];
            if(isValidArray(selectedSeats)){
              let seatIds = getValuesOfJSonObject(selectedSeats);
              seatIds.forEach(seat => {
                let id = seat.id;
                selectedSeats[id].discountedCostWithoutGst = roundNumber(selectedSeats[id].discountedCostWithoutGst - discountPerSeat);
              });
            }
            newState["selectedSeats"]=selectedSeats;
            return newState;
          }

          case UPDATE_EXTRA_SEAT_COUNT: {
            let {isAdd, seatCount, extra_index} = action.payload;
            let tempCount = newState["extraSeatCount"];
            let extraSeatInfoList = newState["extraSeatInfoList"];
            let extraSeatInfoLength = 0;
            if (tempCount==0) {
              extraSeatInfoList = []
            }
            else {
              extraSeatInfoLength = extraSeatInfoList.length;
            }
            if (isAdd) {
              tempCount = tempCount+seatCount;
              let tempExtraSeatInfo = assignExtraSeatInfo(extraSeatInfoLength);
              extraSeatInfoList.push(tempExtraSeatInfo)
            }
            else {
              if (extra_index<=extraSeatInfoLength) {
                tempCount = tempCount-seatCount;
                extraSeatInfoList.splice(extra_index,1);
              }
            }
            newState["extraSeatCount"] = tempCount;
            newState["extraSeatInfoList"] = extraSeatInfoList;
            return newState;
          }

          case ON_EXTRA_SEAT_FORM_CHANGE:{
            let extraSeatFormData = action.payload;
            let {
              extra_index
            } = extraSeatFormData;
            let extraSeatInfoList = newState["extraSeatInfoList"];
            if (isValidNumber(extra_index)&&isValid(extraSeatInfoList[extra_index])) {
              let formKeys = Object.keys(extraSeatFormData);
              formKeys.map((key) => {
                if (key!='extra_index') {
                  if(isValid(extraSeatFormData[key])) {
                    extraSeatInfoList[extra_index][key] = extraSeatFormData[key];
                  }
                }
              })
            }
            newState["extraSeatInfoList"] = extraSeatInfoList;
            return newState;
          }

          case REFRESH_SELECTED_SEATS: {
            let { freshSeats } = action.payload;
            let selectedSeats = newState["selectedSeats"];
            if (isValidArray(selectedSeats) && isValidArray(freshSeats)) {
              for (const seatId in selectedSeats) {
                if (Object.hasOwnProperty.call(selectedSeats, seatId)) {
                  const freshSeat = freshSeats.find(fs => fs.id == seatId);
                  if (freshSeat) {
                    // Preserve passenger form data (fullName, gender, age) and update seat pricing data
                    const existingSeat = selectedSeats[seatId];
                    selectedSeats[seatId] = {
                      ...getFormatedSeatObject(freshSeat),
                      fullName: existingSeat.fullName,
                      gender: existingSeat.gender,
                      age: existingSeat.age
                    };
                  }
                }
              }
              newState["selectedSeats"] = { ...selectedSeats };
            }
            return newState;
          }

          case LOG_OUT_ACTION :
            return initialState;

          case RESET_PASSENGER_FORM:
            newState["extraSeatInfoList"] = [];
            return initialState;

          default:
              return state;
      }
  }
  